import { render } from "./Upgrade.vue?vue&type=template&id=6f164fe2&scoped=true&ts=true"
import script from "./Upgrade.vue?vue&type=script&lang=tsx"
export * from "./Upgrade.vue?vue&type=script&lang=tsx"

import "./Upgrade.vue?vue&type=style&index=0&id=6f164fe2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Profectus/Profectus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f164fe2"]])

export default __exports__